import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "user-menu" }
const _hoisted_2 = {
  key: 0,
  class: "user-menu__changelog-badge-container"
}
const _hoisted_3 = { class: "user-menu__changelog-badge" }
const _hoisted_4 = {
  key: 0,
  class: "user-menu__list"
}
const _hoisted_5 = {
  key: 0,
  class: "user-menu__item"
}
const _hoisted_6 = { class: "user-menu__item" }
const _hoisted_7 = {
  key: 1,
  class: "user-menu__item"
}
const _hoisted_8 = { class: "user-menu__item" }
const _hoisted_9 = {
  key: 2,
  class: "user-menu__item"
}
const _hoisted_10 = {
  key: 3,
  class: "user-menu__item"
}
const _hoisted_11 = {
  key: 4,
  class: "user-menu__item user-menu__item--login"
}
const _hoisted_12 = {
  key: 5,
  class: "user-menu__item user-menu__item--logout"
}
const _hoisted_13 = { class: "user-menu__item user-menu__item--night-mode" }

import { onMounted, ref } from 'vue'

import { HeaderView } from '@/models/header'
import { nightMode } from '@/services/night'
import BasePopup from '@/components/ui/BasePopup.vue'
import { emitter } from '@/services/mitt'
import LanguageSwitcher from '@/app/components/header/LanguageSwitcher.vue'
import ChangelogBadge from '@/app/components/changelog/Badge.vue'
import ChangelogPopupButton from '@/app/components/changelog/PopupButton.vue'
import { auth } from '@/services/auth'
import { streaks16464Variant } from '@/services/ab'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMenu',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const logoutFailurePopup = ref<InstanceType<typeof BasePopup> | null>(null)

const isNightModeActive = ref(false)

function settingsTitle16464(): string {
  return streaks16464Variant() === 'B' ? 'Profile' : 'Settings'
}

function settingsIcon16464(): string {
  return streaks16464Variant() === 'B' ? 'iaccount' : 'isettings'
}

function routeName(link: string): Record<string, string> {
  return { name: link }
}

function showLanguage(): boolean {
  return props.view.showLanguage
}

function isTemporaryUser(): boolean {
  return auth.isTemporaryUser()
}

async function toggleNightMode(): Promise<void> {
  await props.view.toggleNightMode()
  emitter.emit('toggleNightMode')
}

onMounted(() => {
  isNightModeActive.value = nightMode.active
  emitter.on('logoutOfflineFailure', () => {
    logoutFailurePopup.value?.show()
  })
  emitter.on('toggleNightMode', async () => {
    isNightModeActive.value = nightMode.active
  })
})

/**
 * Proxy function to call the view.hideMenu()
 *
 * This function is necessary for Vue to properly handle
 * reactivity and set the view._isMenuHidden property on
 * click outside.
 */
function hideMenu(): void {
  props.view.hideMenu()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "user-menu__toggle",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.view.toggleMenu && __props.view.toggleMenu(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "user-menu__avatar" }, [
        _createElementVNode("span", { class: "user-menu__avatar-icon iconfont iaccount" })
      ], -1),
      _createElementVNode("span", { class: "user-menu__arrow iconfont iarrow-down" }, null, -1)
    ]))]),
    (__props.view.changelog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ChangelogBadge, {
              view: __props.view.changelog
            }, null, 8, ["view"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade-transition" }, {
      default: _withCtx(() => [
        (__props.view.isMenuVisible)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (!isTemporaryUser())
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      to: routeName('billing'),
                      class: "user-menu__link"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("span", { class: "user-menu__icon iconfont iicon-07" }, null, -1),
                        _createTextVNode(" Billing ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: routeName('all_highlights'),
                  class: "user-menu__link"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("span", { class: "user-menu__icon iconfont ihighlights" }, null, -1),
                    _createTextVNode(" Highlights ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"])
              ]),
              (!isTemporaryUser())
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: routeName('settings'),
                      class: "user-menu__link"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(`user-menu__icon user-menu__icon--settings16464 iconfont ${settingsIcon16464()}`)
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(settingsTitle16464()), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: routeName('help'),
                  class: "user-menu__link"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("span", { class: "user-menu__icon iconfont iicon-08" }, null, -1),
                    _createTextVNode(" Support ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"])
              ]),
              (showLanguage())
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createVNode(LanguageSwitcher)
                  ]))
                : _createCommentVNode("", true),
              (__props.view.changelog)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createVNode(ChangelogPopupButton, {
                      class: "user-menu__link",
                      view: __props.view.changelog,
                      "header-view": __props.view
                    }, null, 8, ["view", "header-view"])
                  ]))
                : _createCommentVNode("", true),
              (isTemporaryUser())
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      class: "user-menu__link",
                      to: { name: 'login' }
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("span", { class: "user-menu__icon user-menu__icon--login iconfont ilogin" }, null, -1),
                        _createTextVNode(" Log in ", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("a", {
                      class: "user-menu__link",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.view.logout()))
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("span", { class: "user-menu__icon iconfont iicon-09" }, null, -1),
                      _createTextVNode(" Log out ", -1)
                    ]))])
                  ])),
              _createElementVNode("li", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "user-menu__link" }, [
                  _createElementVNode("span", { class: "user-menu__icon iconfont inight-mode" }),
                  _createTextVNode(" Dark mode ")
                ], -1)),
                _createElementVNode("button", {
                  class: "user-menu__night-mode-toggle",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleNightMode()))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["user-menu__night-mode-toggle-button", {
                'user-menu__night-mode-toggle-button--active':
                  isNightModeActive.value,
              }])
                  }, null, 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(BasePopup, {
      ref_key: "logoutFailurePopup",
      ref: logoutFailurePopup,
      title: "Logout Failure"
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
        _createTextVNode(" We couldn't log you out right now as you seem to be offline. Please check your internet connection and then try again. ", -1)
      ]))]),
      _: 1
    }, 512)
  ])), [
    [_directive_click_outside, hideMenu]
  ])
}
}

})